export const decorateWithCrossDomainLinker = (url) => {
    if (typeof document === 'undefined') {
        return url;
    }
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.hidden = true;
    const originalHref = anchor.href;
    document.body.appendChild(anchor);
    try {
        anchor.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
        const decoratedHref = anchor.href;
        return decoratedHref === originalHref ? url : decoratedHref;
    }
    finally {
        anchor.remove();
    }
};
